export const ScriptLoader = (src) => {
  const script = document.createElement('script')
  const parent = document.getElementsByTagName('script')[0]
  script.async = 1
  script.src = src
  parent.parentNode.insertBefore(script, parent)
}